export type ClassificationInput = { type: string, value: string }

export type ClassificationOutput = { title: string, content: string }

/**
 * Classification service
 * @description 用于获取分类号解释
 */
export interface ClassificationService {
    /**
     * 获取分类号解释
     * @param data 分类号类型和分类号文本
     * @returns 分类号解释
     */
    fetch(data: ClassificationInput): Promise<ClassificationOutput[]>
}

export const ClassificationService = Symbol.for('ClassificationService');
